import React,{ PureComponent } from "react";
import "./NoContent.scss";

class NoContent extends PureComponent{
    render(){
        return <div className={"container"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className={"no-content-text"}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        </div>
    }
}
export default NoContent;